import React from 'react';
import { Row, Col, Modal, Form, Input, Select, Button } from 'antd';
import { contentRsg, materialConRsg } from '@/utils/common/constants';
import BaseComponent from 'components/BaseComponent';
import 'components/Modal/modal.less';
import InputForm from 'components/Form/InputForm';
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

/** 编辑、新建RSS */
@Form.create()
export class AddEditRss extends BaseComponent {

    /* 检查名称 */
    checkName = (row, value, callback) =>{
        const name_max = 50;
        if(value.trim().length > name_max){
            callback(`${window.language['material.maxLength']}${name_max}`);
            return;
        }
        
        var reg = new RegExp(materialConRsg);

        if(reg.test(value.trim())){
            callback(`文件名不能包含以下任何字符: \\ / : * ? " < > |`);      
            return;     
        }

        callback();
    }

    /* 检查URL */
    checkUrl = (row, value, callback) =>{
        if (!value || value.trim().length === 0) {
            callback('');
            return;
        }
        
        const name_max = 100;

        if(value.trim().length > name_max){
            callback(`${window.language['material.maxLength']}${name_max}`);
            return;
        }
        
        if(!/^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/.test(value.trim())) {
            callback(window.language['dynamicText.tip.urlIllegal']);      
            return;     
        }

        callback();
    }

    /* 检查备注 */
    checkRemark = (row, value, callback) =>{
        const remark_max = 200;
        if(value.length > remark_max){
            callback(`${window.language['material.maxLength']}${remark_max}`);
            return;
        }
        
        callback();
    }

    render() {
        const { dynamicTextTitle: { type, title }, visible, dynamicTextData, hideRssHandler, rssHandler, form } = this.props;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 17 },
        };
        const formItemLayout2 = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };
        if (!type || !dynamicTextData) {
            return null;
        }
        let newData = {};
        let readOnlyStyle = {};
        let disabledStyle = {};
        let btnMsg = window.language['common.ok'];
        if (type === '0') {
            newData.content = dynamicTextData.content;
        } else {
            newData = dynamicTextData;
        }
        if (type === '2') {
            readOnlyStyle.readOnly = true;
            disabledStyle.disabled = true;
            btnMsg = window.language['common.close'];
        }
        return (
            visible && 
            <Modal
            title={title}
            visible={visible}
            width={931}
            maskClosable={false}
            onCancel={hideRssHandler}
            className="material-rss-model show-modal-head material-model-style"
            footer={null}
            >
                <div className="material-all-body">
                    <div className="rss-body">
                        <Form>
                            <Row>
                                <Col span={12}>
                                    <FormItem {...formItemLayout} style={{ marginBottom:0 }}>
                                        {getFieldDecorator('id', {
                                            initialValue: newData.id ? newData.id : '',
                                        })(
                                            <Input type="hidden" />
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} className="material-form-top" label={window.language['dynamicText.columns.name']}>
                                        {InputForm({
                                            form,
                                            type: 'input',
                                            name: 'name',
                                            title: window.language['material.columns.name'],
                                            initialValue: newData.name ? newData.name : '',
                                            style: {width: 316},
                                            className: 'ant-input-round',
                                            placeholder: window.language['common.inputContent'],
                                            maxLength: '50',
                                            autoComplete: 'off',
                                            rules: [{
                                                required: true,
                                                message: window.language['common.inputContent']
                                            }, {
                                                validator: this.checkName
                                            }],
                                            onBlur: () => { rssHandler(null, true); },
                                            ...readOnlyStyle
                                        })}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={window.language['dynamicText.columns.nlines']}>
                                        {getFieldDecorator('nlines', {
                                            initialValue: newData.nlines ? newData.nlines + '' : '5',
                                            rules: [{ 
                                                required: true
                                            }]
                                        })(
                                            <Select {...disabledStyle} style={{ width: '316px' }} onBlur={() => { rssHandler(null, true); }}>
                                                <Option value="1">1</Option>
                                                <Option value="2">2</Option>
                                                <Option value="3">3</Option>
                                                <Option value="4">4</Option>
                                                <Option value="5">5</Option>
                                                <Option value="6">6</Option>
                                                <Option value="7">7</Option>
                                                <Option value="8">8</Option>
                                                <Option value="9">9</Option>
                                                <Option value="10">10</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={window.language['dynamicText.columns.model']}>
                                        {getFieldDecorator('model', {
                                            initialValue: newData.model ? newData.model + '' : '0',
                                            rules: [{ 
                                                required: true
                                            }]
                                        })(
                                            <Select {...disabledStyle} style={{ width: '316px' }} onBlur={() => { rssHandler(null, true); }}>
                                                <Option value="0">{window.language['dynamicText.columns.nlinesTitle']}</Option>
                                                <Option value="1">{window.language['dynamicText.columns.nlinesContent']}</Option>
                                                <Option value="2">{window.language['dynamicText.columns.nlinesTitleContent']}</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={window.language['dynamicText.columns.url']}>
                                        {InputForm({
                                            form,
                                            type: 'input',
                                            name: 'url',
                                            title: window.language['dynamicText.columns.url'],
                                            initialValue: newData.url ? newData.url : '',
                                            style: {width: 316},
                                            className: 'ant-input-round',
                                            placeholder: window.language['dynamicText.tip.printUrl'],
                                            maxLength: '100',
                                            autoComplete: 'off',
                                            rules: [{
                                                required: true,
                                                message: window.language['dynamicText.tip.printUrl']
                                            }, {
                                                validator: this.checkUrl
                                            }],
                                            onBlur: () => { rssHandler(null, true); },
                                            ...readOnlyStyle
                                        })}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={window.language['dynamicText.columns.remark']} className="form-rss-remark">
                                        {InputForm({
                                            form,
                                            type: 'textarea',
                                            name: 'remark',
                                            title: window.language['material.columns.remark'],
                                            initialValue: newData.remark ? newData.remark : '',
                                            style: { height: 100, resize: "none", borderRadius: '4px' },
                                            className: 'ant-input-round',
                                            placeholder: window.language['common.inputRemarkContent'].replace("{1}", 200),
                                            maxLength: '200',
                                            autoComplete: 'off',
                                            rules: [{
                                                validator: this.checkRemark
                                            }],
                                            ...readOnlyStyle
                                        })}
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem {...formItemLayout2} label={window.language['dynamicText.columns.preview']} className="form-rss-preview">
                                        {getFieldDecorator('content', {
                                            initialValue: newData.content ? newData.content : ''
                                        })(
                                            <TextArea readOnly />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>                    
                    </div>
                    <div className="material-foot">
                        <Button type="primary" onClick={(e) => { rssHandler(e) }}>{btnMsg}</Button>             
                    </div>
                </div>
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/addEditRss.js